<template>
  <div class="summary-card-container">
    <div class="summary-card">
      <div class="image-icon-container"><img v-bind:src="cardIcon" alt="card icon" /></div>
      <div class="details-display-container">
        <div class="summary-description">{{summaryDescription}}</div>
        <div class="summary-count">{{totalCount}}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'JobDetailSummaryCard',
  props:[
    'cardIcon',
    'summaryDescription',
    'totalCount'
  ],
  data(){
    return{
    };
  },
  computed: {
  },

  beforeMount(){

  },

  updated(){
  }

};
</script>

<style scoped>
  .summary-card-container {
    margin-top:41px;
    display:flex;
    background:var(--white);
    min-height:154px;
    border-radius:15px;
    box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    -webkit-box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    -moz-box-shadow: 0px 0px 4px 2px rgba(180, 180, 180, 0.15);
    width:224px;
  }

  .summary-card {
    border-radius: 15px;
    padding:1.438rem;
    align-items:center;
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    width:100%;
  }

  .image-icon-container img{
    max-width:100%;
  }

  .details-display-container{
    margin-top:21px;
    display:flex;
    flex-direction:column;
  }

  .summary-description{
    font-size:.8rem;
    color:#767676;
    font-weight:600;
    text-align:center;
  }
  .summary-count{
    text-align:center;
    margin-top:.813rem;
    font-size:1.75rem;
    color:#3F3F3F;
    font-weight:600;
  }

  @media only screen and (min-width:1200px) {
    .summary-card-container {
      width: 185px;
    }
  }

  @media only screen and (max-width:1078px) {

  }

  @media only screen and (max-width:990px) {

  }

  @media only screen and (max-width: 767px) {

  }

  @media only screen and (max-width: 565px) {

  }

  @media only screen and (max-width: 420px) {

  }
</style>
